import { styled, Theme } from '@mui/material';

// TODO add colors to library
const hoverBg = '#EBF6F7';

export const sxStyles = {
  headSectionBg: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
  }),
  headSectionText: {
    marginTop: '2rem',

    '& > div:first-of-type': {
      display: 'flex',
    },
  },
  areaTitle: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.75rem 0 0.5rem',

    '& > div:first-of-type': {
      marginRight: '0.5rem',
    },
  },
  majorTitle: {
    wordBreak: 'break-word',
  },
  aboutWrap: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  }),
  aboutTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
    marginRight: '1.5rem',
  }),
  aboutDescription: {
    maxWidth: '640px',
    width: '100%',
  },
  showMoreButton: (theme: Theme) => ({
    color: theme.palette.primary.main,
    textDecoration: 'underline',

    '&:hover': {
      cursor: 'pointer',
    },
  }),
  nearbySchoolsBg: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
  }),
};

export const StyledHeadSectionInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'end',
  maxWidth: '1320px',
  margin: '0 auto',
  position: 'relative',

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

export const StyledHeadSectionInfo = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  maxWidth: '650px',
  width: '100%',
  padding: '1.25rem',
}));

export const StyledPersonalRecommendation = styled('div', {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: color,
  color: theme.palette.common.white,
  borderRadius: '1rem',
  marginRight: '0.625rem',

  '& > div:last-of-type': {
    marginLeft: '0.375rem',
    marginRight: '0.5rem',
  },
}));

export const StyledHeadSectionActions = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '3rem',

  [theme.breakpoints.up('xs')]: {
    flexDirection: 'row',
    marginTop: '2.65rem',
  },
}));

export const StyledFavoritesButton = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 0,
  marginBottom: '1rem',
  height: '48px',
  fontWeight: 600,
  fontSize: '1rem',
  padding: '0.375rem 1rem',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,

  '& > svg:first-of-type': {
    fill: theme.palette.common.white,
    marginRight: '0.625rem',
  },

  '&:hover': {
    cursor: 'pointer',
  },

  [theme.breakpoints.up('xs')]: {
    marginRight: '1rem',
    marginBottom: 0,
  },
}));

export const StyledNotes = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxHeight: '48px',
  fontSize: '1rem',
  fontWeight: 600,
  marginRight: 0,
  marginBottom: '1rem',
  padding: '0.75rem 1rem',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '4px',

  '& > svg:first-of-type': {
    fill: theme.palette.common.white,
    marginRight: '0.75rem',
  },

  '&:hover': {
    cursor: 'pointer',
    backgroundColor: hoverBg,
  },

  [theme.breakpoints.up('sm')]: {
    marginRight: '1rem',
    marginBottom: 0,
  },
}));

// TODO will deploy in next release
// export const StyledWebsiteLink = styled('a')(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   fontWeight: 600,
//   padding: '0.75rem 1.5rem',
//   color: theme.palette.primary.main,
//
//   '& > svg:first-of-type': {
//     marginRight: '0.75rem',
//   },
//
//   '&:hover': {
//     // TODO add color to library
//     backgroundColor: hoverBg,
//   },
// }));

export const StyledMajorPhotoWrap = styled('div')(({ theme }) => ({
  maxWidth: '850px',
  width: '100%',
  margin: '1.5rem auto 0 auto',

  img: {
    position: 'static',
    display: 'block',
    margin: '0 auto',
    borderBottomLeftRadius: '240px',
    maxHeight: '480px',
    height: '100%',
  },

  [theme.breakpoints.up('lg')]: {
    width: '850px',
    margin: '0',

    img: {
      position: 'relative',
      left: '74px',
    },
  },

  [theme.breakpoints.up('xl')]: {
    img: {
      position: 'relative',
      left: '256px',
    },
  },
}));

export const StyledAboutSectionInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  maxWidth: '834px',
  width: '100%',
  padding: '4rem 0',

  [theme.breakpoints.up('xs')]: {
    flexDirection: 'row',
  },
}));
